import React from 'react';
import EnrollmentTemplate from '@/templates/EnrollmentTemplate';
import { useTranslation } from 'react-i18next';
import { Description } from './EmailSentSuccess.styles';

const EmailSentSuccessScreenView = () => {
  const { t } = useTranslation('common');

  return (
    <EnrollmentTemplate bodyPadding="50px 30px" hideBack>
      <Description>{t('screens.enrollment.linkEnrollmentSuccessScreen.description')}</Description>
    </EnrollmentTemplate>
  );
};

export default EmailSentSuccessScreenView;
